import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'
import { setContext } from 'apollo-link-context'
import { createHttpLink } from 'apollo-link-http'
import { RetryLink } from 'apollo-link-retry'

import config from '@/config'

import * as firebase from 'firebase/app'

const retryLink = new RetryLink({
  attempts: {
    max: 1,
    retryIf(error) {
      const retryStatusCodes = [500]
      return retryStatusCodes.includes(error.statusCode)
    },
  },
})

const authLink = setContext(async (_, { headers }) => {
  let token

  try {
    token = await firebase.auth().currentUser.getIdToken(true)
  } catch (e) {
    token = ''
  }

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
      'Accept-Language': localStorage.getItem('language') || 'en',
    },
  }
})

const httpLink = createHttpLink({
  uri: `${config.backendUrl}`,
})

const defaultOptions = {
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
}

const graphqlClient = new ApolloClient({
  link: retryLink.concat(authLink.concat(httpLink)),
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions: defaultOptions,
})

export default graphqlClient
